<template>
  <el-dialog
    top="10vh"
    title="详情"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <Description>
      <DescriptionItem labelWidth="140px" :span="24" label="客户名称">{{
        info.name | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="所属渠道商">{{
        info.distributorName | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="负责人">{{
        info.principal | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="电话">{{
        info.phone | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="邮箱">{{
        info.email | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="所在地址">{{
        address | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="系统管理员账号">{{
        info.account | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="有效期至">{{
        info.expiryDate | formatTime('YYYY-MM-DD')
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="所属角色">{{
        info.roleName | format
      }}</DescriptionItem>
      <DescriptionItem labelWidth="140px" :span="24" label="状态">
        <hl-status
          :iconClass="(enbaleDisableStatus[info.status] || {})['iconClass']"
          :color="(enbaleDisableStatus[info.status] || {})['color']"
          :title="info.statusName"
        ></hl-status>
      </DescriptionItem>
    </Description>
  </el-dialog>
</template>

<script>
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'
import Status from '@/components/CommonTable/Status'
import { format, formatTime } from '@/utils/utils'
import { enbaleDisableStatus } from '@/config/status'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  components: {
    Description,
    DescriptionItem,
    'hl-status': Status
  },
  data() {
    return {
      enbaleDisableStatus,
      info: {}
    }
  },
  created() {
    if (this.row.id) {
      this.getDetail()
    }
  },
  computed: {
    address() {
      return [this.info.province, this.info.city, this.info.region, this.info.address]
        .filter(Boolean)
        .join('')
    }
  },
  filters: {
    format,
    formatTime
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    getDetail() {
      const params = {
        id: this.row.id
      }
      this.$ajax
        .get(this.$api.client.client_detail, params)
        .then((res) => {
          if (res.data) {
            this.info = res.data
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss"></style>
